export default __webpack_public_path__ + "static/media/2190.20811c59.png";